import { render, staticRenderFns } from "./Pep-statement-notification-pagination.vue?vue&type=template&id=12f4a3ae"
import script from "./Pep-statement-notification-pagination.vue?vue&type=script&lang=js"
export * from "./Pep-statement-notification-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports